import { render, staticRenderFns } from "./GoodsConSimple.vue?vue&type=template&id=94d8c712&scoped=true&"
import script from "./GoodsConSimple.vue?vue&type=script&lang=js&"
export * from "./GoodsConSimple.vue?vue&type=script&lang=js&"
import style0 from "./GoodsConSimple.vue?vue&type=style&index=0&id=94d8c712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d8c712",
  null
  
)

export default component.exports